import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import FormInput, {
  InputType,
} from '@/components/BaseLibrary/FormInput/FormInput';
import InputRow from '@/components/InputRow/InputRow';
import { InputName } from '@/utils/validation/inputs';

import type { LeadFormSchemaType } from './LeadForm';

type FormProps = {
  register: UseFormRegister<LeadFormSchemaType>;
  errors: FieldErrors<LeadFormSchemaType>;
  isVertical: boolean;
  classes: Record<string, string>;
  globalClasses: Record<string, string>;
  ownHomeRadios: React.JSX.Element;
  contentStyle?: string;
  evenSpacing?: boolean;
  isOnDark?: boolean;
};

const LeadFormContent = ({
  isVertical,
  classes,
  globalClasses,
  ownHomeRadios,
  contentStyle,
  evenSpacing = false,
  isOnDark = false,
  errors,
  register,
}: FormProps) => {
  const finalInputRowClass = evenSpacing
    ? classes.finalInputRowEvenSpacing
    : classes.finalInputRow;
  return (
    <>
      <div className={contentStyle}>
        <InputRow>
          <FormInput
            label='First Name'
            name={InputName.FIRST_NAME}
            testId='first-name-input'
            type={InputType.TEXT}
            inputMode='text'
            isOnDark={isOnDark}
            error={errors[InputName.FIRST_NAME]?.message}
            register={register}
          />
          <div className={classes.hidden}>
            <FormInput
              label='Address'
              testId='address'
              type={InputType.ADDRESS}
              inputMode='numeric'
              isOnDark={isOnDark}
              error={errors[InputName.ADDRESS]?.message}
              name={InputName.ADDRESS}
              register={register}
            />
          </div>
          <FormInput
            label='Last Name'
            name={InputName.LAST_NAME}
            testId='last-name-input'
            type={InputType.TEXT}
            inputMode='text'
            isOnDark={isOnDark}
            error={errors[InputName.LAST_NAME]?.message}
            register={register}
          />
          {!isVertical && (
            <FormInput
              label='Email'
              name={InputName.EMAIL}
              testId='email-input'
              type={InputType.TEXT}
              inputMode='email'
              isOnDark={isOnDark}
              error={errors[InputName.EMAIL]?.message}
              register={register}
            />
          )}
        </InputRow>

        {isVertical && (
          <InputRow>
            <FormInput
              label='Email'
              name={InputName.EMAIL}
              testId='email-input'
              type={InputType.TEXT}
              inputMode='email'
              isOnDark={isOnDark}
              error={errors[InputName.EMAIL]?.message}
              register={register}
            />
          </InputRow>
        )}

        <InputRow className={finalInputRowClass}>
          <FormInput
            label='ZIP Code'
            testId='zip-input'
            type={InputType.ZIP}
            inputMode='numeric'
            isOnDark={isOnDark}
            error={errors[InputName.ZIP_CODE]?.message}
            name={InputName.ZIP_CODE}
            register={register}
          />
          <FormInput
            label='Phone'
            testId='phone-input'
            type={InputType.TEL}
            inputMode='tel'
            isOnDark={isOnDark}
            error={errors[InputName.PHONE]?.message}
            name={InputName.PHONE}
            register={register}
          />
          {!isVertical && (
            <div className={classes.radioContainer}>
              <p
                className={`${globalClasses.h5} ${classes.homeQuestionHeading}`}
              >
                Do you own your own home?
              </p>
              {ownHomeRadios}
            </div>
          )}
        </InputRow>
      </div>
      {isVertical && ownHomeRadios}
    </>
  );
};

export default LeadFormContent;
